var React = require('react');

function Battery (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Battery"),React.createElement("g",{"id":"layer1","key":2},React.createElement("g",{"id":"g1616"},[React.createElement("path",{"id":"path4015","className":"cls-1","d":"M69,32.5H29l-10,10v40l10,10H69l10-10v-40Z","key":0}),React.createElement("path",{"id":"path4017","className":"cls-1","d":"M79,52.5h30","key":1}),React.createElement("path",{"id":"path4019","className":"cls-1","d":"M79,72.5h30","key":2})]))]);
}

Battery.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Battery;

Battery.default = Battery;
